module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("修改密码"), _c('span', {
    staticClass: "required"
  }, [_vm._v("(请5分钟内修改完成)")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "status-icon": "",
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "prop": "oldPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "请输入旧密码"
    },
    model: {
      value: (_vm.ruleForm.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "oldPassword", $$v)
      },
      expression: "ruleForm.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "freshPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "minlength": "8",
      "maxlength": "16",
      "autocomplete": "off",
      "placeholder": "新密码8-16位，且包含数字，符号和字母"
    },
    model: {
      value: (_vm.ruleForm.freshPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "freshPassword", $$v)
      },
      expression: "ruleForm.freshPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "minlength": "8",
      "maxlength": "16",
      "placeholder": "请再次输入新密码"
    },
    model: {
      value: (_vm.ruleForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "checkPass", $$v)
      },
      expression: "ruleForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3cd02e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/changePassword.vue
// module id = 63HX
// module chunks = 57